export default {
  isLoaded: false,
  developMode: (localStorage.getItem('developMode') === 'true') ? true : false,
  language: !localStorage.getItem('lang') ? 'ru' : localStorage.getItem('lang'),
  enterRouter: null,
  // data
  countries: null,
  offers: null,
  goods: null,
  operators: null,
  couriers: null,
  lastUpdate: null,
  lastVersion: null,
  dashboardStatistic: null,
  selectedDateFrom: null,
  selectedDateTo: null,
  selectedDateFromFirst: null,
  selectedDateToFirst: null,
  selectedDateFromSecond: null,
  selectedDateToSecond: null,
  selectedDateCreatedTo: null,
  selectedDateCreatedFrom: null,
  selectedDateReceiptFrom: null,
  selectedDateReceiptTo: null,
  selectedMonthFrom: null,
  selectedMonthTo: null,
  // country filter
  selectedCountry: [],
  // offer filter
  selectedOffer: null,
  // operator filter
  selectedOperator: null,
  selectedCouriers: null,
  selectedWebmaster: null,
  webmasters: [],
  byWmFilter: true,
  byManualFilter: '',
  OldbyWmFilter: true,
  webFilter: null,
  webSelectedFilter: null,
  webNewFilter: [],
  webNewManualFilter: null,
  webNewSelectedFilter: [],
  webNewManualSelectedFilter: null,
  webAddTagFilter: null,
}



// WEBPACK FOOTER //
// ./src/api/Storage.js